import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { INFO } from './NotificationTypes';

const typeDetails = {
  INFO: {
    icon: 'info',
  },
  ERROR: {
    icon: 'bug',
  },
  WARNING: {
    icon: 'exclamation-triangle',
  },
  SUCCESS: {
    icon: 'check',
  },
};


const Notification = (props) => {
  const {
    id,
    type = INFO,
    text = '',
    duration,
    onClose,
    isClosing = false,
  } = props;

  const hasDuration = (duration !== undefined);

  let isClosingClass = '';
  if (isClosing) isClosingClass = ' is-closing';

  let durationClassName = '';
  if (!isClosing && hasDuration) durationClassName = ` duration-${duration}`;

  let timedClassName = '';
  if (hasDuration) timedClassName = ' timed';

  const { icon } = typeDetails[type];

  return (
    <div className={`message ${type.toLowerCase()}${timedClassName}${durationClassName}${isClosingClass}`}>
      <span className="message-icon">
        <FontAwesomeIcon icon={icon} />
      </span>
      <span className="text-container">
        <span className="text">{text}</span>
        <div className="progress-container"><div className="message-progress" /></div>
      </span>
      <button
        type="button"
        className="close-icon"
        onClick={onClose && (() => { onClose({ id }); })}
      >
        <FontAwesomeIcon icon="times" />
      </button>
    </div>);
};

Notification.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  isClosing: PropTypes.bool,
};

export default Notification;
